export default "__VITE_ASSET__CQ$rmAr$__"